const configuredBaseUrl = import.meta.env.VITE_AXON_API_BASE_URL;
const API_BASE_URL = (
  configuredBaseUrl || (import.meta.env.DEV ? "http://127.0.0.1:8000" : "https://api.axonleads.ru")
).replace(/\/$/, "");

export class NotificationsApiError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = "NotificationsApiError";
    Object.assign(this, details);
  }
}

async function request(idToken, path, options = {}) {
  const hasJsonBody = options.jsonBody !== undefined;
  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method: options.method || "GET",
      headers: {
        Authorization: `Bearer ${idToken}`,
        ...(hasJsonBody ? { "Content-Type": "application/json" } : {}),
      },
      ...(hasJsonBody ? { body: JSON.stringify(options.jsonBody) } : {}),
      cache: "no-store",
      credentials: "omit",
      redirect: "error",
      referrerPolicy: "no-referrer",
    });
  } catch {
    throw new NotificationsApiError("Нет связи с AxonLeads. Проверьте интернет и повторите.");
  }
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    const error = payload?.error || {};
    throw new NotificationsApiError(
      typeof error.message === "string" ? error.message : "Не получилось загрузить уведомления.",
      { status: response.status, code: error.code },
    );
  }
  return payload;
}

export function fetchNotifications(idToken) {
  return request(idToken, "/v1/notifications");
}

export function markNotificationsRead(idToken, ids) {
  return request(idToken, "/v1/notifications/read", {
    method: "POST",
    jsonBody: ids?.length ? { ids } : {},
  });
}
